import type { GetProvidersInput, ProviderCreateDto, ProviderDto, ProviderUpdateDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProviderService {
  apiName = 'Inventory';

  create = (input: ProviderCreateDto) =>
    this.restService.request<any, ProviderDto>({
      method: 'POST',
      url: '/api/inventory/providers',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/providers/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, ProviderDto>({
      method: 'GET',
      url: `/api/inventory/providers/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetProvidersInput) =>
    this.restService.request<any, PagedResultDto<ProviderDto>>({
      method: 'GET',
      url: '/api/inventory/providers',
      params: { filterText: input.filterText, name: input.name, description: input.description, address: input.address, contact: input.contact, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: ProviderUpdateDto) =>
    this.restService.request<any, ProviderDto>({
      method: 'PUT',
      url: `/api/inventory/providers/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
